module.exports = __webpack_public_path__ + "img/galleria10.d7ab51ae.jpg";